import React from 'react'
import PropTypes from 'prop-types'
import DateTime from 'react-datetime'
import moment from 'moment'
import { toastr } from 'react-redux-toastr'
import _ from 'lodash'

import momenttz from '../../../helpers/momenttz'

import './AvailableDatesNav.sass'
import { GiPreviousButton, GiNextButton } from "react-icons/gi";

const AvailableDatesNav = (props) => {
	const { eventDate, availableDates, sizePerPage, getFleetEvents, setPropStates, clearTimer, isTripHistory } = props;
	// console.log('PROPS AvailableDatesNav:', props)

	const validDate = (current) => {
		return _.indexOf(availableDates, current.format('YYYY-MM-DD')) !== -1
	}

	const onDateChanged = (current) => {
		if (!moment(current, 'MM/DD/YYYY', true).isValid()) {
			toastr.error('', 'Please enter valid date value.')
			return
		}

		toastr.removeByType('error')
		setPropStates({ eventDate: current }, () => clearTimer())
		getFleetEvents(1, sizePerPage, true, current)
	}

	const getPreviousEvents = () => {
		const pos = _.indexOf(availableDates, eventDate)

		if (pos === -1 && availableDates.length) {
			const arr = availableDates.filter((date) => {
				return (momenttz(date).format('YYYY-MM-DD') < momenttz(eventDate).format('YYYY-MM-DD'))
			})

			if (arr.length) {
				setPropStates({ eventDate: arr[arr.length - 1] }, () => clearTimer())
				getFleetEvents(1, sizePerPage, true, arr[arr.length - 1])
			} else {
				toastr.info('', `No previous ${isTripHistory ? 'trips' : 'events'} available`)
			}
		} else if (pos > 0) {
			setPropStates({ eventDate: availableDates[pos - 1] }, () => clearTimer())
			getFleetEvents(1, sizePerPage, true, availableDates[pos - 1])
		} else {
			toastr.info('', `No previous ${isTripHistory ? 'trips' : 'events'} available`)
		}
	}

	const getNextEvents = () => {
		const pos = _.indexOf(availableDates, eventDate)

		if (pos === -1 && availableDates.length) {
			const arr = availableDates.filter((date) => {
				return (momenttz(date).format('YYYY-MM-DD') > momenttz(eventDate).format('YYYY-MM-DD'))
			})

			if (arr.length) {
				setPropStates({ eventDate: arr[0] }, () => clearTimer())
				getFleetEvents(1, sizePerPage, true, arr[0])
			} else {
				toastr.info('', `No future ${isTripHistory ? 'trips' : 'events'} available`);
			}
		} else if (pos > -1 && pos < (availableDates.length - 1)) {
			setPropStates({ eventDate: availableDates[pos + 1] }, () => clearTimer())
			getFleetEvents(1, sizePerPage, true, availableDates[pos + 1])
		} else {
			toastr.info('', `No future ${isTripHistory ? 'trips' : 'events'} available`)
		}
	}

	return (
		<div className="AvailableDatesNav">
			<div className="arrows">
				<svg className="previous-date" onClick={getPreviousEvents} width='18' height='18' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g>
					<path fill="none" d="M0 0h24v24H0z" /><path d="M12 10.667l9.223-6.149a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.624 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416v5.733z" /></g>
				</svg>
			</div>
			<div className="input event-date">
				<DateTime
					inputProps={{ readOnly: true }}
					value={moment(eventDate).format('MM/DD/YYYY')}
					dateFormat="MM/DD/YYYY"
					timeFormat={false}
					closeOnSelect
					isValidDate={validDate}
					onChange={onDateChanged}
				/>
			</div>
			<div className="arrows">
				<svg className="next-date" onClick={getNextEvents} width='18' height='18' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="IconChangeColor" transform="scale(-1, 1)"><g>
					<path fill="none" d="M0 0h24v24H0z" id="mainIconPathAttribute" /><path d="M12 10.667l9.223-6.149a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.624 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416v5.733z" id="mainIconPathAttribute" /></g>
				</svg>
			</div>
		</div>
	)
}

AvailableDatesNav.propTypes = {
	eventDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(moment),
	]).isRequired,
	availableDates: PropTypes.arrayOf(PropTypes.string).isRequired,
	sizePerPage: PropTypes.number.isRequired,
	getFleetEvents: PropTypes.func.isRequired,
	setPropStates: PropTypes.func.isRequired,
	clearTimer: PropTypes.func.isRequired
}

export default AvailableDatesNav;
